import React from "react";
import useRazorpay from "react-razorpay";
import { useSelector } from "react-redux";
import LoadingComponent from "../../LoadingComponent";
import { ErrorTemplate } from "../../../templates";
import { useVerifyOrderMutation } from "../../../hooks";

function Credit() {
  const [Razorpay] = useRazorpay();
  const { razorpayDetails } = useSelector((state) => state.order);
  const {
    mutate: verifyOrderMutation,
    status: verifyStatus,
    error: verifyError
  } = useVerifyOrderMutation();

  const { details } = useSelector((state) => state.user);
  const razorpayInstanceRef = React.useRef(null);

  const razorpayHandler = React.useCallback((response) => {
    verifyOrderMutation(response);
  }, []);

  const combinedLoading = React.useMemo(
    () => razorpayDetails?.loading || verifyStatus === "pending",
    [razorpayDetails?.loading, verifyStatus]
  );

  const razorpayOptions = React.useMemo(
    () => ({
      name: "BlueBees",
      description: "Bluebees payment",
      image: "https://bluebees.club/favicon.ico",
      prefill: {
        name: `${details.firstName || ""} ${details.lastName || ""}`,
        email: `${details.email || "d2c@globalbees.com"}`,
        contact: `${details.phoneNumber}`
      },
      theme: { color: "#000000" },
      handler: razorpayHandler,
      key: razorpayDetails.key,
      order_id: razorpayDetails.paymentGatewayTxnId
    }),
    [details, razorpayDetails, razorpayHandler]
  );

  const handlePayment = () => {
    razorpayInstanceRef.current.open();
  };

  React.useEffect(() => {
    if (razorpayDetails.paymentGatewayTxnId && !razorpayInstanceRef.current) {
      razorpayInstanceRef.current = new Razorpay(razorpayOptions);
      razorpayInstanceRef.current.open();
    }
  }, [razorpayDetails.paymentGatewayTxnId, Razorpay, razorpayOptions]);

  if (combinedLoading) return <LoadingComponent />;

  if (verifyStatus === "error")
    return <ErrorTemplate error={verifyError?.message} />;

  return (
    <div className="payment-right-credit">
      <div className="pay-now-btn">
        <button type="button" onClick={handlePayment}>
          Pay Using Razorpay
        </button>
      </div>
    </div>
  );
}

export default Credit;
